'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dDashboard$002dView$0024$0024anon$002428 from "./presto.-Dashboard-View$$anon$28.js";
import * as $j_presto$002etypes$0024$002dCredential$002dKind$0024 from "./presto.types$-Credential-Kind$.js";
import * as $j_presto$002etypes$0024$002dDashboard$002dCredential$002dCount$0024 from "./presto.types$-Dashboard-Credential-Count$.js";
var $p;
/** @constructor */
function $c_Lpresto_DashboardView$$anon$27() {
  this.aLd = null;
  this.aL5 = null;
  this.aL6 = false;
  this.aLe = null;
  this.aLf = false;
  this.aLi = null;
  this.aLb = null;
  this.aLc = false;
  this.aL7 = null;
  this.aL8 = false;
  this.aL9 = null;
  this.aLa = false;
  this.aLg = false;
  this.aLh = false;
  this.aLd = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.aLi = "DashboardCredentialCount";
}
export { $c_Lpresto_DashboardView$$anon$27 as $c_Lpresto_DashboardView$$anon$27 };
$p = $c_Lpresto_DashboardView$$anon$27.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_DashboardView$$anon$27;
/** @constructor */
function $h_Lpresto_DashboardView$$anon$27() {
}
export { $h_Lpresto_DashboardView$$anon$27 as $h_Lpresto_DashboardView$$anon$27 };
$h_Lpresto_DashboardView$$anon$27.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.J = (function() {
  return this.aLd;
});
$p.L = (function() {
  if ((!this.aL6)) {
    this.aL5 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.aL6 = true;
  }
  return this.aL5;
});
$p.O = (function() {
  if ((!this.aLf)) {
    this.aLe = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.aLf = true;
  }
  return this.aLe;
});
$p.E = (function() {
  return this.aLi;
});
$p.t = (function() {
  if ((!this.aLc)) {
    this.aLb = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("kind", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("used", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("registered", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.aLc = true;
  }
  return this.aLb;
});
$p.M = (function() {
  if ((!this.aL8)) {
    this.aL7 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dCredential$002dKind$0024.$m_Lpresto_types$CredentialKind$().cx(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().bB, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().bB, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.aL8 = true;
  }
  return this.aL7;
});
$p.Q = (function() {
  if ((!this.aLa)) {
    this.aL9 = new $j_presto$002e$002dDashboard$002dView$0024$0024anon$002428.$c_Lpresto_DashboardView$$anon$28();
    this.aLa = true;
  }
  return this.aL9;
});
$p.w = (function() {
  if ((!this.aLh)) {
    this.aLg = false;
    this.aLh = true;
  }
  return this.aLg;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee150) => ((p) => \u03b4scrutinee150.cGt(p)))($j_presto$002etypes$0024$002dDashboard$002dCredential$002dCount$0024.$m_Lpresto_types$DashboardCredentialCount$())));
});
var $d_Lpresto_DashboardView$$anon$27 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_DashboardView$$anon$27, "presto.DashboardView$$anon$27", ({
  GT: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_DashboardView$$anon$27 as $d_Lpresto_DashboardView$$anon$27 };
//# sourceMappingURL=presto.-Dashboard-View$$anon$27.js.map
